export default __webpack_public_path__ + "static/media/professor.8cbc5ac2.png";